module.exports = __webpack_public_path__ + "static/img/CR@2x.29aea29c.jpg";